<template>
  <div
    v-loading="loading"
    class="main-content"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(170,170,170,0.5)"
  >
    <div class="section operations">
      <div class="triggers">
        <div>
          <div class="input-label">{{ $t('CargoMsg.Cargo_Filter') }}</div>
          <el-input v-model="keyword" style="width: 180px;" />
          <el-button v-permission="['button_AirRegion_add']" type="primary" @click="newHandler">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
          <el-button v-permission="['button_AirRegion_edit']" type="primary" @click="editHandler">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
          <el-button v-permission="['button_AirRegion_delete']" type="primary" @click="delHandler">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
        </div>
      </div>
    </div>
    <div style="flex-grow: 1;min-height: 350px;">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="filteredRowData"
        style="height: 100%;"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <!-- 新增/编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="regionDialog.visible"
      :title="regionDialog.title"
      width="500px"
      :close-on-click-modal="false"
      class="region-form"
    >
      <el-form :label-width="$selectByLang('70px', '120px')" label-position="left">
        <el-form-item :label="$t('CargoMsg.Cargo_Code')" class="lable-blue">
          <el-input v-model="regionDialog.form.code" :placeholder="$t('CargoMsg.Cargo_MustBEntered')" style="width: 150px;" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Name')" class="lable-blue">
          <el-input v-model="regionDialog.form.name" :placeholder="$t('CargoMsg.Cargo_MustBEntered')" style="width: 150px;" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_EnglishNamed')">
          <el-input v-model="regionDialog.form.englishName" placeholder=" " style="width: 230px;" />
        </el-form-item>
      </el-form>
      <div class="section" style="height: 290px;">
        <span class="title">{{ $t('CargoMsg.Cargo_RegionalPorts') }}</span>
        <cargo-ag-grid
          :grid-options="regionDialog.gridOptions"
          :column-defs="regionDialog.columnDefs"
          :row-data="regionDialog.form.airPortRegion||[]"
          @gridReady="params=>{regionDialog.gridApi=params.api}"
        />
      </div>
      <span slot="footer" style="display: flex;">
        <el-button type="primary" @click="addAirPortRegion">{{ $t('CargoMsg.Cargo_add') }}</el-button>
        <el-button type="primary" @click="delAirPortRegion">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
        <div style="flex-grow: 1;" />
        <el-button type="primary" @click="commitHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="regionDialog.visible=false">{{ $t('Message.Cancel') }}</el-button>
      </span>
    </el-dialog>
    <air-port-select-dialog :visible.sync="airPortSelectDialog.visible" :codes="airPortSelectDialog.codes" @callback="selectAirPorts" />
  </div>
</template>

<script>
import airPortSelectDialog from '@/views/cargo/v0/AirExport/components/airConfig/airPortSelectDialog'
import { deepCopy } from '@/utils/commonUtil'
import { loadSpecificBasicInfo } from '@/api/cache'
import { getListByAirRegion } from '@/api/basicData/airPortRegion'
import { saveAirRegion, deleteAirRegion } from '@/api/basicData/airRegion'

export default {
  name: 'AirRegionList',
  components: { airPortSelectDialog },
  data() {
    return {
      loading: false,
      keyword: '',
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。
        onRowDataChanged: event => {
          /* 清除单选行 */
          this.selectedNode = null
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onCellDoubleClicked: event => {
          if (this.$checkPermission(['button_AirRegion_edit'])) {
            this.editHandler()
          }
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: { componentParent: this }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Code'),
          field: 'code',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Name'),
          field: 'name',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishNamed'),
          field: 'englishName',
          width: 140
        }
      ],
      rowData: [],
      selectedNode: null,
      gridApi: null,
      regionDialog: {
        visible: false,
        title: '',
        form: { code: '', name: '', englishName: '', airPortRegion: [] },
        deletedAirPortRegionKeys: [],
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。
          onRowDataChanged: event => {
            /* 清除单选行 */
            this.regionDialog.selectedNode = null
            event.api.clearFocusedCell()
          },
          onCellFocused: event => {
            const nodes = event.api.rowModel.rowsToDisplay
            this.regionDialog.selectedNode = nodes[event.rowIndex] || null
          },
          onSortChanged: event => {
            // 重置单选行
            if (this.regionDialog.selectedNode) {
              const rowIndex = this.regionDialog.selectedNode.rowIndex
              this.regionDialog.selectedNode = null
              event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
            }
          },
          context: { componentParent: this }
        },
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_PODcode'),
            field: 'airPortId',
            width: 430
          }
        ],
        selectedNode: null,
        gridApi: null
      },
      airPortSelectDialog: {
        visible: false,
        codes: []
      }
    }
  },
  computed: {
    filteredRowData() {
      return this.rowData.filter(p => {
        const keyword = this.keyword.trim()
        if (!keyword) {
          return true
        }
        if (p.code.toLowerCase().indexOf(keyword.toLowerCase()) > -1) {
          return true
        }
        if (p.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1) {
          return true
        }
        if (p.englishName.toLowerCase().indexOf(keyword.toLowerCase()) > -1) {
          return true
        }
        return false
      })
    }
  },
  created() {
    this.queryHandler()
  },
  methods: {
    queryHandler() {
      this.loading = true
      loadSpecificBasicInfo('AirRegion').then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    newHandler() {
      this.regionDialog.title = this.$t('CargoMsg.Cargo_NewAirTransportationArea')
      this.regionDialog.form = { code: '', name: '', englishName: '', airPortRegion: [] }
      this.regionDialog.deletedAirPortRegionKeys = []
      this.regionDialog.visible = true
    },
    async editHandler() {
      if (!this.selectedNode) {
        return
      }
      const data = this.selectedNode.data
      this.regionDialog.title = this.$t('CargoMsg.Cargo_EditAirTransportationArea')
      if (!data.airPortRegion) {
        this.loading = true
        await getListByAirRegion({ airRegionUuid: data.uuid }).then(res => {
          data.airPortRegion = res.data
        }).finally(() => {
          this.loading = false
        })
      }
      this.regionDialog.form = deepCopy(data)
      this.regionDialog.deletedAirPortRegionKeys = []
      this.regionDialog.visible = true
    },
    addAirPortRegion() {
      this.airPortSelectDialog.codes = Array.from(this.regionDialog.form.airPortRegion, p => p.airPortId)
      this.airPortSelectDialog.visible = true
    },
    selectAirPorts(airPorts) {
      const airPortRegion = this.regionDialog.form.airPortRegion
      for (const item of airPorts) {
        if (airPortRegion.findIndex(p => p.airPortId === item.code) === -1) {
          airPortRegion.push({ airPortId: item.code, airRegionUuid: '' })
        }
      }
    },
    delAirPortRegion() {
      const cell = this.regionDialog.gridApi.getFocusedCell()
      const row = cell ? this.regionDialog.gridApi.rowModel.rowsToDisplay[cell.rowIndex].data : null
      if (row) {
        if (row.uuid) {
          this.regionDialog.deletedAirPortRegionKeys.push(row.uuid)
        }
        const index = this.regionDialog.form.airPortRegion.findIndex(p => p === row)
        this.regionDialog.form.airPortRegion.splice(index, 1)
      }
    },
    commitHandler() {
      const form = this.regionDialog.form
      if (!form.code.trim()) {
        this.$message.warning(this.$t('AirExport.PleaseEnterACode'))
        return
      }
      if (this.rowData.findIndex(p => p.code === form.code && p.uuid !== form.uuid) > -1) {
        this.$message.warning(this.$t('AirExport.CodeExistsPleaseReEnter'))
        return
      }
      if (!form.name.trim()) {
        this.$message.warning(this.$t('AirExport.PleaseEnterAName'))
        return
      }
      if (form.airPortRegion.length === 0) {
        this.$message.warning(this.$t('AirExport.PleaseAddARegionalPort'))
        return
      }
      this.loading = true
      saveAirRegion(form, { deletedAirPortRegionKeys: this.regionDialog.deletedAirPortRegionKeys.join(',') }).then(res => {
        this.queryHandler()
        this.regionDialog.visible = false
      }).catch(() => {
        this.loading = false
      })
    },
    delHandler() {
      if (this.selectedNode) {
        this.$confirm(this.$t('AirExport.AreYouWantToDelete'), this.$t('Message.Confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.loading = true
          deleteAirRegion({ uuid: this.selectedNode.data.uuid }).then(res => {
            this.queryHandler()
          }).catch(() => {
            this.loading = false
          })
        }).catch()
      }
    }
  }
}
</script>

<style scoped lang="scss">
#app .main-content ::v-deep {
  .el-loading-mask {
    z-index: 999999;
  }
}
.input-label {
  display: inline-block;
  width: 60px;
  color: #666666;
}
.region-form .lable-blue ::v-deep {
  .el-form-item__label {
    color: blue !important;
  }
}
</style>
